.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 6px;
  border: none;
  font-size: 0.825rem;
  font-weight: 500;
  transition: all;
}
.btn:disabled {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 50%;
}
.btn:focus,
.btn:focus-visible {
  outline: 2px solid blue;
}

/* Default button style */
.custom_default {
  background-color: #007bff;
  color: white;
  border: none;
}

.custom_default:hover {
  background-color: #0056b3;
}

/* Destructive button style */
.custom_destructive {
  background-color: #dc3545;
  color: white;
  border: none;
}

.custom_destructive:hover {
  background-color: #c82333;
}

/* Outline button style */
.custom_outline {
  border: 1px solid #6c757d;
  background-color: transparent;
  color: #6c757d;
}

.custom_outline:hover {
  background-color: #f8f9fa;
}

/* Secondary button style */
.custom_secondary {
  background-color: #6c757d;
  color: white;
  border: 1px solid transparent;
}

.custom_secondary:hover {
  background-color: #5a6268;
}

/* Ghost button style */
.custom_ghost {
  background-color: transparent;
  color: #007bff;
  border: 1px solid transparent;
}

.custom_ghost:hover {
  background-color: #f8f9fa;
}

/* Link button style */
.custom_link {
  background-color: transparent;
  color: #007bff;
  text-decoration: underline;
  border: none;
}

.custom_link:hover {
  text-decoration: none;
}

/* Size Styles */
.custom_default_size {
  height: 40px;
  padding: 0 16px;
}

.custom_sm_size {
  height: 32px;
  padding: 0 12px;
}

.custom_lg_size {
  height: 48px;
  padding: 0 24px;
}

.custom_icon_size {
  width: 40px;
  height: 40px;
}
